/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall"



export default {


    async fetchTotalFeesInvoiced(data){
        let response = await apiCall("fees/billing/total", data);
        return response;
    },

    async fetchTotalFeesPaid(data){
        let response = await apiCall("fees/payment/total", data);
        return response;
    },

    async fetchCollectionPercentage(data){
        let response = await apiCall("fees/payment/percentage", data);
        return response;
    },

    async fetchTotalStudentsPopulation(data){
        let response = await apiCall("fees/student/total", data);
        return response;
    },

    async fetchTotalStudentsBilled(data){
        let response = await apiCall("fees/student/total/billed", data);
        return response;
    },

    async fetchStatement(data){
        let response = await apiCall("fees/statement", data);
        return response;
    },

    async fetchStudentStatement(data){
        let response = await apiCall("school/feesprofile/student_statement", data);
        return response;
    },

    async fetchStudentBalance(student_id){
        let response = await apiCall("school/feesprofile/student_balance", {"student_id":student_id});
        return response;
    },

    async payFees(data){
        let response = await apiCall("fees/payment/new", data);
        return response;
    },

    async addBatch(batch_name, start_date, end_date){
        let data={
            "batch_name":batch_name,
            "start_date":start_date,
            "end_date":end_date
        }
        let response = await apiCall("fees/billing/batch/add", data);
        return response;
    },

    async updateStudentFeesGroup(student_id, group_id){
        let data={
            "student_id":student_id,
            "fees_group_id":group_id
        }
        let response = await apiCall("fees/student/group/update", data);
        return response;
    },

    async billStudent(student_id){
        let response = await apiCall("fees/student/bill", {"student_id":student_id});
        return response;
    },

    async syncStudents(class_id, flag){
        let response = await apiCall("fees/student/sync", {"ref_class_id":class_id, "student_flag":flag});
        return response;
    },


    async syncClasses(){
        let response = await apiCall("fees/student/class/sync", {"source":"admin"});
        return response;
    },

    async getGroupStructure(group_id){
        let response = await apiCall("fees/structure/info", {"fees_group_id":group_id});
        return response;
    },

    async defineGroupStructure(group_id, vote_id, amount){
        let data = {
            "amount":amount,
            "vote_id":vote_id,
            "fees_group_id":group_id
          }
        let response = await apiCall("fees/structure/define", data);
        return response;
    },

    async createFeesGroup(group_name, description){
        let data = {
            "group_name":group_name,
            "description":description
          }
        let response = await apiCall("fees/group/add", data);
        return response;
    },


    async createFeesVote(vote_name, income_account, cash_account){
        let data = {
            "vote_name":vote_name,
            "income_account":income_account,
            "cash_account":cash_account
          }
        let response = await apiCall("fees/structure/votes/add", data);
        return response;
    },


    async getCurrentBatch(){
    
        let response = await apiCall("fees/batch/current", []);
        return response;
    },

    async getClassInvoiceBreakdown(data){
    
        let response = await apiCall("fees/invoice/breakdown/class", data);
        return response;
    },

    async fetchFeesGroups(){
    
        let response = await apiCall("fees/group/list", []);
        return response;
    },

    async fetchFeesGroupStructure(){
    
        let response = await apiCall("fees/group/structure/list", []);
        return response;
    },


    async fetchRecentStudents(){
    
        let response = await apiCall("fees/student/list/recent", []);
        return response;
    },

    async getFeesGraph(data){
    
        let response = await apiCall("fees/graph", data);
        return response;
    },

    async fetchAllStudents(data){
        let response = await apiCall("school/student/filter_students", data);
        return response;
    },

    async fetchAllClasses(){
    
        let response = await apiCall("fees/student/classes/list", []);
        return response;
    },

    async fetchBiillingBatches(){
    
        let response = await apiCall("fees/batch/list", []);
        return response;
    },

    async fetchFeesGroupInfo(group_id){
    
        let data={"fees_group_id":group_id}
        let response = await apiCall("fees/group/info", data);
        return response;
    },

    async fetchFeesVotes(){
    
        let response = await apiCall("fees/votes/list", []);
        return response;
    },
    
    async searchStudent(hint){
    
        let data={"hint":hint}
        let response = await apiCall("fees/student/search", data);
        return response;
    },


    async fetchRecentPayments(data){
    
        let response = await apiCall("fees/payment/recent", data);
        return response;
    },

    async fetchRecurringDiscounts(data){
    
        let response = await apiCall("fees/discount/recurring/list", data);
        return response;
    },


    async createDiscount(data){
    
        let response = await apiCall("fees/discount/add", data);
        return response;
    },

    async fetchRecentDiscounts(data){
    
        let response = await apiCall("fees/discount/recent", data);
        return response;
    },


    async configureFeesDiscount(data){
    
        let response = await apiCall("fees/config/discount", data);
        return response;
    },


    async fetchFeesConfig(data){
    
        let response = await apiCall("fees/config/list", data);
        return response;
    },
    

    async fetchQuickStat(){
    
        let response = await apiCall("fees/stat", []);
        return response;
    },

    async fetchFeesDefaulters(data){
    
        let response = await apiCall("fees/defaulters", data);
        return response;
    },

    async fetchStudentProfile(student_id){
    
        let response = await apiCall("fees/student/info", {"student_id":student_id});
        return response;
    },


    async importSchoolPay(data){
    
        let response = await apiCall("fees/schoolpay/import", data);
        return response;
    },


    async fetchBillingRecords(data){
    
        let response = await apiCall("fees/billing/list", data);
        return response;
    },


    async addCustomBill(studentIds, voteId, amount, description){

        const data = {
            'student_ids':studentIds, 
            'vote_id':voteId, 
            'amount':amount, 
            'description':description
        }
    
        let response = await apiCall("fees/billing/custom/add", data);
        return response;
    },




    async syncResidence(){
        let response = await apiCall("fees/residence/sync", {"source":"admin"});
        return response;
    },


    async fetchResidences(){
    
        let response = await apiCall("fees/residence/list", []);
        return response;
    },

    async fetchBillingConfig(){
    
        let response = await apiCall("fees/billing/config/list", []);
        return response;
    },


    async createBillingConfig(data){
    
        let response = await apiCall("fees/billing/config/add", data);
        return response;
    },


    async autoBillStudents(data){
    
        let response = await apiCall("fees/billing/auto", data);
        return response;
    },


    async updateFeesGroup(group_id, group_name, description){

        let data = {
            "group_id": group_id,
            "group_name":group_name,
            "description":description
          }
    
        let response = await apiCall("fees/group/update", data);
        return response;
    },


    async updateBatch(batch_id, batch_name, start_date, end_date){
        let data={
            "batch_id": batch_id,
            "batch_name":batch_name,
            "start_date":start_date,
            "end_date":end_date
        }
        let response = await apiCall("fees/billing/batch/update", data);
        return response;
    },
    

    async activateBilling(studentId){
    
        const data={
            "student_id":studentId
        }
        let response = await apiCall("fees/student/activate", data);
        return response;
    },

    async deactivateBilling(studentId){
    
        const data={
            "student_id":studentId
        }
        let response = await apiCall("fees/student/deactivate", data);
        return response;
    },

    async deleteFeesVote(voteId){
    
        const data={
            "vote_id":voteId
        }
        let response = await apiCall("fees/vote/delete", data);
        return response;
    },


    async declineBill(studentId){
    
        const data={
            "student_id":studentId
        }
        let response = await apiCall("fees/student/unbill", data);
        return response;
    },


    async switchBillingBatch(batchId){
    
        const data={
            "batch_id":batchId
        }
        let response = await apiCall("fees/batch/current/switch", data);
        return response;
    },

    
    async deleteBillingConf(configId){
    
        const data={
            "config_id":configId
        }
        let response = await apiCall("fees/billing/config/delete", data);
        return response;
    },
    

    async autoAssignFeesGroup(configId){
    
        const data={
            "config_id":configId
        }
        let response = await apiCall("fees/feesgroup/assign/auto", data);
        return response;
    },
    

    async setConfig(configCode, configValue){
    
        const data={
            "config_code": configCode,
            "config_value": configValue
        }
        let response = await apiCall("school/feesconfig/configure", data);
        return response;
    },

    async assignFeesGroupSelection(feesGroupId, studentsIds){
    
        const data={
            "fees_group_id": feesGroupId,
            "student_ids": studentsIds
        }
        let response = await apiCall("school/student/multi_assign_fees_group", data);
        return response;
    },

    async fetchBillingPreview(studentsIds){
    
        const data={
            "student_ids": studentsIds
        }
        let response = await apiCall("school/studentbilling/billing_overview", data);
        return response;
    },

    async billSelection(studentsId){
    
        const data={
            "student_ids": studentsId
        }
        let response = await apiCall("school/studentbilling/bill_selection", data);
        return response;
    },
    
    async fetchRecentTransactions(){
    
        let response = await apiCall("school/studentbilling/recent_transactions", []);
        return response;
    },
   
    async fetchPaymentPreview(studentId){
    
        const data={
            "student_id": studentId
        }
        let response = await apiCall("school/studentbilling/payment_preview", data);
        return response;
    },

    async fetchBilledRatio(){
    
        let response = await apiCall("school/billingstat/billed_ratio", []);
        return response;
    },

    async fetchBilledSum(){
    
        let response = await apiCall("school/billingstat/sum_billed_amount", []);
        return response;
    },

    async fetchPaidSum(){
    
        let response = await apiCall("school/billingstat/sum_paid_amount", []);
        return response;
    },

    async fetchDiscountedSum(){
        let response = await apiCall("school/billingstat/sum_discounted_amount", []);
        return response;
    },
    async fetchCollectionOverview(){
        let response = await apiCall("school/billingstat/collection_summary_data", []);
        return response;
    },

    async fetchAllTransactions(data){
        let response = await apiCall("school/studentbilling/filter_transactions", data);
        return response;
    },

    async fetchStudentBilledSum(studentId){
        const data={
            "student_id":studentId
        }
    
        let response = await apiCall("school/feesprofile/sum_billed_amount", data);
        return response;
    },

    async fetchStudentPaidSum(studentId){
        const data={
            "student_id":studentId
        }
        let response = await apiCall("school/feesprofile/sum_paid_amount", data);
        return response;
    },

    async fetchStudentDiscountedSum(studentId){
        const data={
            "student_id":studentId
        }
        let response = await apiCall("school/feesprofile/sum_discounted_amount", data);
        return response;
    },

    async fetchFeesDefauterCount(){
    
        let response = await apiCall("school/studentbilling/count_defaulters", []);
        return response;
    },
    
    async configureFeesGroup(group_id, config){
        const data = {
            "fees_group_id": group_id,
            "config_data": config
        }
    
        let response = await apiCall("school/feesgroupconfig/create", data);
        return response;
    },

    async fetchFeesGroupConfig(group_id){
        const data = {
            "fees_group_id": group_id,
        }
    
        let response = await apiCall("school/feesgroupconfig/get", data);
        return response;
    },

    async fetchGrossBalanceRatio(){
    
        let response = await apiCall("school/billingstat/gross_balance_ratio", []);
        return response;
    },
    
    async fetchBillingSummary(){
    
        let response = await apiCall("school/billingstat/billing_summary", []);
        return response;
    },

    async deleteStudent(studentId){
        const data = {
            "student_id": studentId
        }
        let response = await apiCall("school/student/delete_student", data);
        return response;
    },

    async deleteFeesGroup(feesGroupId){
        const data = {
            "fees_group_id": feesGroupId
        }
        let response = await apiCall("school/feesgroup/delete", data);
        return response;
    },
    
    async updateFeesVote(vote_id, vote_name, income_account, cash_account){
        let data = {
            "vote_id":vote_id,
            "vote_name":vote_name,
            "income_account":income_account,
            "cash_account":cash_account
          }
        let response = await apiCall("school/feesvote/update_vote", data);
        return response;
    },

    async fetchOnlineFeesPayment(data){
    
        let response = await apiCall("school/collectors/schoolcollectordata/list_collector_data", data);
        return response;
    },

    async checkOnlinePayments(opening_date, closing_date){
        const data = {
            "opening_date": opening_date,
            "closing_date": closing_date
        }
        let response = await apiCall("school/collectors/schoolcollectordata/check_payments", data);
        return response;
    },

    async processOnlinePayments(data){
        return await apiCall("school/collectors/schoolcollectordata/process_payments", data);
    },
    async deleteOnlinePayments(data){
        return await apiCall("school/collectors/schoolcollectordata/delete_records", data);
    },
    async changeSettlementBank(data){
        return await apiCall("school/collectors/schoolcollectordata/change_settlement_bank", data);
    },
    async markReconciled(data){
        return await apiCall("school/collectors/schoolcollectordata/mark_as_reconciled", data);
    },
    async markUnreconciled(data){
        return await apiCall("school/collectors/schoolcollectordata/mark_as_unreconciled", data);
    },
    async reconcilePayments(data){
        return await apiCall("school/collectors/schoolcollectordata/sync_with_bank", data);
    },
    async unassignFeesGroups(){
        let response = await apiCall("school/student/reset_fees_groups", []);
        return response;
    },
    async syncFeesGroups(){
        let response = await apiCall("school/student/sync_fees_groups", []);
        return response;
    },

    async importFeesDefaulters(data){
        return await apiCall("school/studentbilling/import_defaulters", data);
    },
    async postStudentAdvance(data){
        return await apiCall("school/studentdeferredfees/register_deferred_fees", data);
    },
    async fetchWalletStatement(data){
        return await apiCall("school/studentwallet/wallet_statement", data);
    },
    async fetchWalletBalances(data){
        return await apiCall("school/studentwallet/balance_list", data);
    },
    async fetchWalletStats(data){
        return await apiCall("school/studentwallet/student_stats", data);
    },
    async withdrawWalletFunds(data){
        return await apiCall("school/studentwallet/withdraw", data);
    },
    async depositWalletFunds(data){
        return await apiCall("school/studentwallet/deposit", data);
    },
    async purgeImportedDefaulters(){
        return await apiCall("school/studentbilling/purge_opening_defaulters", []);
    },
    async fetchAdvanceFeesList(data){
        return await apiCall("school/studentbilling/advance_fees_list", data);
    },
    async fetchAdvanceFeesPreview(studentId){
        return await apiCall("school/studentbilling/advance_fees_preview", { "student_id": studentId });
    },
    // Allocations are dated by each vote's invoice date on the server; no transaction_date is sent.
    async reconcileAdvanceFees(studentId){
        return await apiCall("school/studentbilling/reconcile_advance_fees", { "student_id": studentId });
    }
   
} 
